// assets
import { IconShieldLock, IconUser } from '@tabler/icons';
import permissioncheck from 'utils/permissioncheck';

// ==============================|| SETTINGS MENU ITEMS ||============================== //

const children = [
  {
    id: 'users',
    perm: 'user.read',
    title: 'Pengguna',
    type: 'item',
    url: '/users/active',
    icon: IconUser,
    breadcrumbs: false
  },
  {
    id: 'accesscode',
    perm: 'pengaturan.read',
    title: 'Izin Kode Akses Murid',
    type: 'item',
    url: '/settings/accesscode',
    icon: IconShieldLock,
    breadcrumbs: false
  },
  {
    id: 'roles',
    perm: 'role.read',
    title: 'Jabatan',
    type: 'item',
    url: '/settings/roles',
    icon: IconShieldLock,
    breadcrumbs: false
  }
];
const setting = {
  id: 'setting',
  title: '',
  type: 'group',
  children: []
};

children.forEach((element) => {
  if (element.perm) {
    if (permissioncheck(element.perm)) {
      setting.children.push(element);
    }
  } else {
    setting.children.push(element);
  }
});

export default setting;
